import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetorajsthancab() {



  const cardData =
  {
    keyword: 'Pune to Rajasthan Cab Online Booking',
    heading: 'Sanavi Travels: Pune to Rajasthan Cab Online Booking',
    headingDescription: 'Sanavi Travels offers reliable Pune to Rajasthan Cab Online Booking, providing safe, comfortable, and hassle-free transportation for families, corporate travelers, tourists, and groups planning trips from Pune to Rajasthan. Our fleet of sedans, SUVs, and luxury cabs is well-maintained with spacious seating, air-conditioning, and ample luggage space, ensuring a smooth and relaxing long-distance journey. With professional chauffeurs, flexible one-way and round-trip cab options, transparent pricing, and 24/7 online booking support, Sanavi Travels guarantees punctual, reliable, and stress-free travel. We provide convenient doorstep pickup across Pune including Hinjewadi, Wakad, Baner, Kothrud, Hadapsar, Pimpri-Chinchwad, Swargate, and Pune Railway Station, covering popular Rajasthan destinations such as Jaipur, Udaipur, Jodhpur, Mount Abu, Ajmer, Pushkar, and Jaisalmer. Choose Sanavi Travels for trusted Pune to Rajasthan cab online booking, delivering comfort, safety, and a seamless long-distance travel experience.',

    top: 'Top Places to Visit in Rajasthan with Sanavi Travels',


"topPlaces": [
  {
    "title": "Amber Fort, Jaipur",
    "description": "Amber Fort, located near Jaipur, is a magnificent hilltop fort known for its stunning Rajput architecture, intricate carvings, and grand courtyards. Visitors can enjoy elephant rides, panoramic views of Maota Lake, and explore palaces adorned with mirrors and frescoes."
  },
  {
    "title": "City Palace, Udaipur",
    "description": "City Palace in Udaipur is a sprawling complex of palaces, courtyards, and gardens overlooking Lake Pichola. Known for its architectural grandeur, museums, and royal artifacts, it reflects the rich heritage of the Mewar dynasty and offers breathtaking views of the city and lakes."
  },
  {
    "title": "Mehrangarh Fort, Jodhpur",
    "description": "Mehrangarh Fort is a massive fortress overlooking Jodhpur, showcasing exquisite Rajput architecture and intricate carvings. The fort houses museums with royal artifacts, weaponry, and paintings. Panoramic views of the Blue City make it a photographer’s delight."
  },
  {
    "title": "Jaisalmer Fort",
    "description": "Jaisalmer Fort, also known as Sonar Quila, is a living fort in the Thar Desert, famous for its golden sandstone walls and bustling markets. Visitors can explore palaces, temples, and havelis within the fort, experiencing the medieval charm of Rajasthan."
  },
  {
    "title": "Hawa Mahal, Jaipur",
    "description": "Hawa Mahal, or the Palace of Winds, is a five-story pink sandstone palace in Jaipur. Famous for its ornate façade with 953 small windows, it was built for royal ladies to observe street life without being seen. It is an iconic symbol of Jaipur and Rajasthani architecture."
  },
  {
    "title": "Pushkar Lake and Brahma Temple",
    "description": "Pushkar Lake is a sacred water body surrounded by ghats and temples, with the famous Brahma Temple nearby. Pilgrims perform rituals and take holy dips, while visitors enjoy the vibrant atmosphere of the town, including colorful markets and cultural events."
  },
  {
    "title": "Ranthambore National Park",
    "description": "Ranthambore National Park is a wildlife sanctuary in Rajasthan, famous for its Bengal tigers and diverse fauna. The park features ancient forts, lakes, and grasslands, offering safari experiences for wildlife enthusiasts and photographers."
  },
  {
    "title": "Chittorgarh Fort",
    "description": "Chittorgarh Fort is one of India’s largest forts, symbolizing Rajput valor and history. It includes palaces, temples, towers, and the iconic Vijay Stambh. The fort attracts history lovers and tourists interested in Rajasthan’s royal legacy."
  },
  {
    "title": "Bikaner – Junagarh Fort",
    "description": "Junagarh Fort in Bikaner is a well-preserved fort featuring palaces, temples, and museums. Known for its intricate carvings, balconies, and courtyards, it showcases the grandeur of Bikaner’s royal heritage and Rajasthani architecture."
  },
  {
    "title": "Mount Abu and Dilwara Temples",
    "description": "Mount Abu is Rajasthan’s only hill station, offering cool climate, scenic viewpoints, and lakes. The Dilwara Temples near Mount Abu are renowned for their stunning marble carvings, intricate architecture, and spiritual ambiance, attracting pilgrims and tourists alike."
  }
]
,




"services": [
  {
    "name": "Pune to Rajasthan Cab Online Booking",
    "description": "Pune to Rajasthan Cab Online Booking provides a convenient, safe, and comfortable long-distance travel solution. Fully air-conditioned vehicles with spacious seating and ample luggage space ensure a smooth journey. Professional chauffeurs manage route planning, traffic, and punctual pickups, making one-way or round trips hassle-free. Ideal for families, corporate travelers, or groups seeking a reliable and affordable Pune to Rajasthan travel experience."
  },
  {
    "name": "Rajasthan Cab from Pune",
    "description": "Rajasthan Cab from Pune offers a dependable travel option for those commuting between Pune and Rajasthan. Air-conditioned cabs with professional chauffeurs provide a safe, comfortable, and timely journey. Suitable for families, corporate groups, friends, or solo travelers, this service ensures flexibility in pickup and drop-off locations and stress-free long-distance travel."
  },
  {
    "name": "AC Cab Pune to Rajasthan",
    "description": "AC Cab Pune to Rajasthan guarantees a cool and comfortable journey for long-distance travel. Spacious air-conditioned vehicles with ample luggage space and smooth ride quality ensure a pleasant travel experience even in hot weather. Experienced chauffeurs handle routes efficiently and ensure timely pickups, making this service ideal for families, corporate groups, and tourists seeking comfort and convenience."
  },
  {
    "name": "Luxury Cab Rajasthan Trip",
    "description": "Luxury Cab Rajasthan Trip offers a premium travel experience for passengers seeking comfort and style. Fully air-conditioned luxury vehicles with modern amenities provide a relaxing journey from Pune to Rajasthan. Professional chauffeurs ensure safe navigation, punctual pickups, and a smooth ride. Perfect for couples, corporate travelers, or families looking for a high-end travel experience."
  },
  {
    "name": "Family Cab Rajasthan",
    "description": "Family Cab Rajasthan is designed for families traveling from Pune to Rajasthan. Spacious cabs with air-conditioning, luggage space, and comfortable seating make long journeys enjoyable. Professional drivers ensure safety, punctuality, and convenience, making this service ideal for vacations, weekend trips, or family excursions."
  },
  {
    "name": "Outstation Cab Rajasthan",
    "description": "Outstation Cab Rajasthan provides a reliable solution for travelers seeking long-distance transportation from Pune to Rajasthan. Fully air-conditioned vehicles with experienced chauffeurs ensure a smooth, safe, and stress-free journey. Perfect for solo travelers, families, or corporate groups, this service supports flexible travel plans including one-way or round trips."
  },
  {
    "name": "Affordable Cab Rajasthan",
    "description": "Affordable Cab Rajasthan offers budget-friendly travel without compromising on comfort or safety. Fully air-conditioned vehicles with professional chauffeurs provide a smooth and reliable journey. Ideal for students, families, or groups, this service ensures economical, convenient, and stress-free long-distance travel."
  },
  {
    "name": "Chauffeur Driven Cab Rajasthan",
    "description": "Chauffeur Driven Cab Rajasthan ensures a professional and relaxing travel experience. Experienced drivers handle navigation, traffic, and route planning while passengers enjoy air-conditioned, spacious vehicles with ample luggage space. Perfect for families, groups, corporate travelers, or solo passengers seeking comfort, safety, and punctuality on Pune to Rajasthan trips."
  },
  {
    "name": "Best Cab Pune to Rajasthan",
    "description": "Best Cab Pune to Rajasthan offers a premium long-distance travel experience. Fully air-conditioned, well-maintained vehicles with professional chauffeurs provide safety, comfort, and punctuality. Ideal for families, corporate travelers, groups, or solo tourists, this service guarantees a smooth, reliable, and enjoyable Pune to Rajasthan journey."
  },
  {
    "name": "Pune Rajasthan Taxi",
    "description": "Pune Rajasthan Taxi is a dependable travel solution for long-distance trips. Spacious air-conditioned vehicles with professional chauffeurs ensure comfort, safety, and reliability. Flexible pickup and drop options make this service suitable for families, corporate groups, or friends traveling from Pune to Rajasthan."
  },
  {
    "name": "Tourist Cab Rajasthan",
    "description": "Tourist Cab Rajasthan is perfect for travelers planning sightseeing or leisure trips from Pune to Rajasthan. Fully air-conditioned cabs with spacious interiors and professional drivers ensure a safe, smooth, and timely journey. Ideal for families, groups, or solo tourists seeking a hassle-free long-distance travel experience."
  },
  {
    "name": "Long Distance Cab Pune",
    "description": "Long Distance Cab Pune specializes in providing safe and comfortable travel for long-distance routes such as Pune to Rajasthan. Air-conditioned vehicles with professional chauffeurs ensure a stress-free journey. Suitable for family trips, corporate travel, or leisure excursions, this service combines convenience, comfort, and punctuality for travelers."
  },
  {
    "name": "One Way Cab Rajasthan",
    "description": "One Way Cab Rajasthan provides a convenient, cost-effective, and comfortable solution for travelers going from Pune to Rajasthan without requiring a return trip. Fully air-conditioned vehicles and professional chauffeurs ensure a safe, timely, and stress-free journey, ideal for families, corporate travelers, or solo passengers."
  },
  {
    "name": "Round Trip Cab Rajasthan",
    "description": "Round Trip Cab Rajasthan offers a flexible travel option for travelers planning to return to Pune after visiting Rajasthan. Fully air-conditioned, well-maintained vehicles with professional chauffeurs ensure a safe, comfortable, and timely round trip. Suitable for family vacations, corporate travel, or group tours, providing reliable long-distance travel."
  },
  {
    "name": "Online Cab Booking Pune",
    "description": "Online Cab Booking Pune allows passengers to conveniently book cabs for Pune to Rajasthan trips from anywhere at any time. Users can select vehicle type, pickup and drop locations, date, and trip duration with instant confirmation. Fully air-conditioned vehicles with professional chauffeurs provide a smooth, safe, and comfortable journey, making online booking hassle-free and reliable."
  }
],
"tableData": [
  ["Pune to Rajasthan Cab Online Booking", "Rajasthan Cab from Pune"],
  ["AC Cab Pune to Rajasthan", "Luxury Cab Rajasthan Trip"],
  ["Family Cab Rajasthan", "Outstation Cab Rajasthan"],
  ["Affordable Cab Rajasthan", "Chauffeur Driven Cab Rajasthan"],
  ["Best Cab Pune to Rajasthan", "Pune Rajasthan Taxi"],
  ["Tourist Cab Rajasthan", "Long Distance Cab Pune"],
  ["One Way Cab Rajasthan", "Round Trip Cab Rajasthan"],
  ["Online Cab Booking Pune", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Pune to Rajasthan Cab Online Booking with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels provides reliable and convenient cab services from Pune to Rajasthan, perfect for family trips, business travel, and long-distance journeys."
  },
  {
    "WhyChooseheading": "Comfortable and Well‑Maintained Cabs",
    "WhyChoosedescription": "Travel in air‑conditioned, clean, and regularly serviced cabs for a safe and comfortable journey from Pune to Rajasthan."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our licensed drivers are courteous, professional, and familiar with Pune to Rajasthan routes, ensuring timely and hassle-free travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels offers clear and upfront pricing for Pune to Rajasthan cab bookings, including fuel, tolls, and driver allowances."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with online bookings, travel inquiries, and itinerary updates."
  },
  {
    "WhyChooseheading": "Flexible Travel Options",
    "WhyChoosedescription": "Choose from one-way, round-trip, or customized cab packages tailored to your Pune to Rajasthan travel plans."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All cabs are thoroughly cleaned and sanitized before each trip to ensure passenger safety and hygiene."
  },
  {
    "WhyChooseheading": "Reliable and On‑Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for Pune to Rajasthan cab travel."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide online cab booking from Pune to Rajasthan?',
    answer: 'Yes, Sanavi Travels offers convenient online cab booking services from Pune to Rajasthan.'
  },
  {
    question: 'How can I book a cab online from Pune to Rajasthan?',
    answer: 'You can book easily through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of cabs are available for Pune to Rajasthan travel?',
    answer: 'Sanavi Travels provides sedans, SUVs, and premium cars suitable for long-distance journeys.'
  },
  {
    question: 'Are drivers experienced for the Pune to Rajasthan route?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with Pune to Rajasthan routes to ensure safe and smooth travel.'
  },
  {
    question: 'Can I select custom pickup and drop-off locations?',
    answer: 'Absolutely. You can choose your preferred pickup and drop-off points for your Pune to Rajasthan journey.'
  },
  {
    question: 'Is the Pune to Rajasthan cab service available 24x7?',
    answer: 'Yes, Sanavi Travels provides round-the-clock services for bookings and travel assistance.'
  },
  {
    question: 'Are the vehicles sanitized before trips?',
    answer: 'Yes, all cabs are thoroughly cleaned and sanitized before each journey.'
  },
  {
    question: 'What payment options are available for online cab bookings?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your Pune to Rajasthan trip.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Ajay Mehta',
    feedback: 'Booked a Pune to Rajasthan cab online with Sanavi Travels. Smooth booking process, comfortable cab, and professional driver!',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Ritu Sharma',
    feedback: 'Excellent online booking experience! The cab was clean and the journey was hassle-free. Highly recommend Sanavi Travels.',
    rating: 5
  }
];






















































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];










const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Rajasthan Cab Online Booking - Sanavi Travels",
  "description": "Book Pune to Rajasthan cabs online with Sanavi Travels. AC and luxury cabs for family trips, outstation journeys, long-distance travel, one-way or round trips, tourist trips, and comfortable chauffeur-driven service.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1600"
  }
};






  return (
    <div>
<Helmet>
  <title>
    Pune to Rajasthan Cab Online Booking | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Hire AC and luxury cabs from Pune to Rajasthan with Sanavi Travels. Perfect for family trips, outstation journeys, long-distance travel, one-way or round trips, tourist trips, and safe chauffeur-driven service."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/63.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetorajsthancab;